@if (!serviceaftale && !isLoading && !errorMessage) {
  <div class="page__nav">
    <a [routerLink]="'/aftale'" title="Tilbage til oversigten" class="nav-to-links go-back grey-light">
      <mat-icon>chevron_left</mat-icon>
      <span>Tilbage til oversigten</span>
    </a>
  </div>
  <div class="topbar topbar--has-submenu"></div>
  <div class="page__content page__content--has-submenu contract contract--details">
    <div class="card">
      <p>Det angivne aftalenr. findes ikke i EGIS.</p>
      <p>Er det en fejl? Kontakt superbruger el. EGIS admin.</p>
      <p>
        Vil du oprette en ny serviceaftale?
        <a [routerLink]="['/aftale/create']" [queryParams]="{ okKundeAftaleNr: okKundeAftaleNr }">Opret ny serviceaftale</a>
      </p>
    </div>
  </div>
}
@if (errorMessage) {
  <div class="page__content page__content--has-submenu contract contract--details">
    <div class="card">
      <p>Det angivne aftalenr. kan ikke indlæses pga følgende fejl:</p>
      <p>{{ errorMessage }}</p>
    </div>
  </div>
}
@if (serviceaftale && !isLoading) {
  @if (updatedAftale) {
    <div class="info-line">
      <mat-icon svgIcon="obs-solid"></mat-icon>
      <div class="flex">
        <strong>Redigeret af {{ updatedAftale?.modifiedBy }}</strong>
        &nbsp;-&nbsp;
        <button type="button" class="btn-icon underline" (click)="refresh()">opdater og se ændringer</button>
      </div>
    </div>
  }
  <div class="page__nav">
    <app-back-button [text]="'Tilbage'" [altLink]="'/aftale'" [altText]="'Aftale overblik'" idparameter="okKundeAftaleNr"></app-back-button>
    <div class="contract__info">
      <span>{{ serviceaftale.serviceAbonnement?.kundeType?.text }}</span>
      <mat-icon [svgIcon]="getProductIcon(serviceaftale)" [matTooltip]="getProductIcon(serviceaftale) | titlecase"></mat-icon>
      <div class="icon-with-text">
        {{ serviceaftale.okKundeAftaleNr }}
        <app-copy [content]="serviceaftale.okKundeAftaleNr" class="margin--left-xs" [matTooltip]="'Kopiér aftale nummer'"></app-copy>
      </div>
    </div>
    <mat-selection-list #subpage [multiple]="false" [hideSingleSelectionIndicator]="true" (selectionChange)="selectionChanged($event)">
      <mat-list-option [selected]="page == 'Abonnement'" value="Abonnement">Abonnement</mat-list-option>
      <mat-list-option [selected]="page == 'Ordrer'" value="Ordrer">Ordrer</mat-list-option>
      <mat-list-option [selected]="page == 'Historik'" value="Historik">Historik</mat-list-option>
      <mat-list-option [selected]="page == 'Opkraevninger'" value="Opkraevninger">Opkrævninger</mat-list-option>
    </mat-selection-list>
    <hr class="bottom-sep" />
    <app-kunde-info [kunde]="serviceaftale.kunde"></app-kunde-info>
  </div>
  <div class="topbar topbar--has-submenu">
    @if (serviceaftale.isActive) {
      <div class="contract-state contract-state--active">
        <mat-icon svgIcon="checkmark"></mat-icon>
        {{ serviceaftale.serviceaftaleState.text }}
      </div>
    }
    @if (!serviceaftale.isActive) {
      <div class="contract-state contract-state--inactive">
        <mat-icon svgIcon="alert-solid"></mat-icon>
        {{ serviceaftale.serviceaftaleState.text }}
      </div>
    }
    <div
      class="timestamp"
      title="Serviceaftale sidst redigeret {{
        serviceaftale.modifiedOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' }
      }} af {{ serviceaftale.modifiedBy }}"
      >
      <strong>Ændret:&nbsp;</strong>
      {{ serviceaftale.modifiedOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }}
      <mat-icon [matTooltip]="serviceaftale.modifiedBy" class="cursor-help" svgIcon="avatar"></mat-icon>
    </div>
    <div
      class="timestamp"
      title="Serviceaftale oprettet {{
        serviceaftale.createdOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' }
      }} af {{ serviceaftale.createdBy }}"
      >
      <strong>Oprettet:&nbsp;</strong>
      {{ serviceaftale.createdOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' } }}
      <mat-icon [matTooltip]="serviceaftale.createdBy" class="cursor-help" svgIcon="avatar"></mat-icon>
    </div>
    <div class="topbar__actions">
      <app-opfoelgning-action
        [opfoelgningList]="serviceaftale.opfoelgningList"
        (opfoelgningChange)="onOpfoelgningChanged($event)"
        [entityNo]="serviceaftale.serviceAftaleNo"
        [serviceaftale]="serviceaftale"
      ></app-opfoelgning-action>
      @if (page == 'Historik') {
        <app-select-filter
          [filterOptions]="auditHistoryTypesKeys"
          (filterChange)="selectedAuditHistoryType = $event"
          cachename="aftale"
        ></app-select-filter>
      } @else {
        @if (page == 'Ordrer' || page == 'Abonnement') {
          <button (click)="openFastOrdreNoteDialog()" type="button" class="blue btn-icon">
            @if (!serviceaftale.fastOrdreNote) {
              <mat-icon svgIcon="edit"></mat-icon>
            }
            @if (serviceaftale.fastOrdreNote) {
              <mat-icon svgIcon="edit-solid"></mat-icon>
            }
            <span [class.bold]="serviceaftale.fastOrdreNote">Fast ordre note</span>
          </button>
        }
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="createTilkald()" [disabled]="!canWrite">Tilkald</button>
          @if (canCreateEftersyn) {
            <button mat-menu-item (click)="createEftersyn()" [disabled]="!canWrite">Eftersyn</button>
          }
          <button mat-menu-item (click)="createOpstart()" [disabled]="!canWrite">Opstart</button>
        </mat-menu>
        @if (canServiceaftaleBeReactivated()) {
          <button
            (click)="reactivateServiceAgreement()"
            [disabled]="!canReactivate"
            type="button"
            class="red btn-icon"
            >
            <mat-icon svgIcon="undo"></mat-icon>
            <span>Fortryd opsigelse</span>
          </button>
        }
        @if (serviceaftale.slutopgoerelse && !serviceaftale.slutopgoerelse.isCompleted) {
          <button
            type="button"
            class="blue btn-icon"
            [routerLink]="['/slutopgoerelse', serviceaftale.okKundeAftaleNr, 'edit']"
            [disabled]="!showSlutopgoerelser"
            >
            <mat-icon svgIcon="edit"></mat-icon>
            <span>Slutopgørelse</span>
          </button>
        }
        @if (naervarmeUrl && serviceaftale.okKundeAftaleNr && serviceaftale.kunde?.kundeExtendedInformation?.harNaervarmeAftale) {
          <button
            type="button"
            class="blue btn-icon"
            (click)="openNaervarme()"
            >
            <mat-icon>link</mat-icon>
            <span>Se aftale i Nærvarme</span>
          </button>
        }
        @if (
          (this.serviceaftale.serviceaftaleState.state == serviceaftaleStateEnum.CreatedPending ||
          this.serviceaftale.serviceaftaleState.state == serviceaftaleStateEnum.Active) &&
          this.serviceaftale.endDate == null
          ) {
          <button
            type="button"
            class="btn-icon red"
            [routerLink]="'cancel'"
            >
            <mat-icon svgIcon="delete"></mat-icon>
            <span>Opsig</span>
          </button>
        }
        @if (page == 'Ordrer' && serviceaftale.serviceaftaleState.state != serviceaftaleStateEnum.Terminated) {
          <button
            class="btn-icon green"
            matTooltip="Opret ny ordre"
            [matMenuTriggerFor]="menu"
            >
            <mat-icon svgIcon="add"></mat-icon>
            <span>Opret ny ordre</span>
          </button>
        }
        @if (!serviceaftale.anonymiseret) {
          <button (click)="anonymise()" type="button" class="btn-icon" [disabled]="!isGDPR">
            <mat-icon svgIcon="anonymize" matTooltip="Anynomiser service aftalen, ordrer og øvrig kunde information"></mat-icon>
            Anonymiser
          </button>
        }
      }
    </div>
  </div>
  <div class="page__content page__content--has-submenu contract contract--details">
    <ng-container>
      @if (page == 'Abonnement') {
        <app-abonnement
          [serviceaftale]="serviceaftale"
          [tilvalgGroups]="tilvalgGroups"
          (reactivateServiceAgreement)="reactivateServiceAgreement()"
          (serviceaftaleChanged)="onServiceAftaleChange($event)"
        ></app-abonnement>
      }
      @if (page == 'Ordrer') {
        <app-ordre [serviceaftale]="serviceaftale"></app-ordre>
      }
      @if (page == 'Historik') {
        <app-history
          [entityId]="serviceaftale.id"
          [entityType]="entityType"
          [auditHistoryTypeFilter]="selectedAuditHistoryType"
        ></app-history>
      }
      @if (page == 'Opkraevninger') {
        <app-opkraevninger [serviceaftale]="serviceaftale"></app-opkraevninger>
      }
    </ng-container>
  </div>
}
